import React, { useState } from "react";
import classes from "./BuchungsDetails.module.css"
import ErrorMessage from "../../StudioErstellen/ErrorMessage";

import { useBooking } from "../../../store/bookingStore";

export const BuchungsDetails = ({ nextSlide }) => {
  const { bookingData, updateBookingData } = useBooking();
  const [errors, setErrors] = useState({
    projectName: "",
    description: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateBookingData(name, value);
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {
      projectName: "",
      description: ""
    };
    let isValid = true;

    if (!bookingData?.projectName?.trim()) {
      newErrors.projectName = "Projektname ist erforderlich";
      isValid = false;
    }

    if (!bookingData?.description?.trim()) {
      newErrors.description = "Projektbeschreibung ist erforderlich";
      isValid = false;
    } else if (bookingData.description.trim().length < 10) {
      newErrors.description = "Projektbeschreibung muss mindestens 10 Zeichen lang sein";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    if (validateForm()) {
      nextSlide();
    }
  };

  return (
    <div className={classes.container}>
        <h1 className={`${classes.title} titleSemibold2`}>Was planst du?</h1>
        <p className={`${classes.subtitle} slimRegularSmallText`}>Beschreibe dein Projekt, sodass der Host dir bestmöglich dabei helfen kann.</p>
        <div className={classes.formContainer}>
            <input value={bookingData?.projectName} name="projectName" type="text" placeholder="Projektname" className={`${classes.input} slimRegularLarge`} onChange={handleInputChange} />
            {errors.projectName && <ErrorMessage style={{marginTop: "0px"}}>{errors.projectName}</ErrorMessage>}
            <input value={bookingData?.companyName} name="companyName" type="text" placeholder="Firmenname (optional)" className={`${classes.input} slimRegularLarge`} onChange={handleInputChange} />
            <textarea value={bookingData?.description} name="description" placeholder="Projektbeschreibung" className={`${classes.textarea} slimRegularLarge`} onChange={handleInputChange} />
            {errors.description && <ErrorMessage style={{marginTop: "0px"}}>{errors.description}</ErrorMessage>}
        </div>
        <div className={classes.bookingTotal}>
            <button className={classes.weiterButton} onClick={handleNext}>Weiter</button>
        </div>
    </div>
  );
};

export default BuchungsDetails;